import React from 'react';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import LaunchIcon from '@mui/icons-material/Launch';
export const TaskLink = ({ taskId }) => {
    return (React.createElement(IconButton, null,
        React.createElement(Link, { target: "_blank", href: `https://to-do.live.com/tasks/id/${taskId}/details` },
            React.createElement(LaunchIcon, null))));
};
